import request from '@/axios'

// // (rad1)-02-提交评测
// export function getRadList(data) {
//   return request({
//     url: process.env.VUE_APP_BASE_API + '/api_rad/rad_three/getRadList',
//     method: 'post',
//     data
//   })
// }

// 02-确认发送rad3邀请函
export function affirmSendInvitation(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_three/affirmSendInvitation',
    method: 'post',
    data
  })
}

// 03-获取方案颜色选项详情
export function getRadSelectInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_three/getRadSelectInfo',
    method: 'post',
    data
  })
}

// 04-提交客户选择
export function addCustomerSelected(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_three/addCustomerSelected',
    method: 'post',
    data
  })
}

// 05-获取评测结果
export function getRadResultInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_three/getRadResultInfo',
    method: 'post',
    data
  })
}
